<template>
  <div v-if="getSign">
    <div class="more-product-information-trigger">
      <button
        class="button"
        :class="showProductInformation && 'active'"
        role="button"
        @click.prevent="showProductInformation = !showProductInformation"
      >
        {{ languageStrings.show_product_information }}
      </button>
    </div>

    <div
      v-if="getSign"
      class="column is-full more-product-information"
      :class="showProductInformation ? 'show' : null"
    >
      <div class="columns is-multiline">
        <div class="column base-information__description">
          <div class="base-information">
            <div>
              <div
                v-if="getSign.description"
                v-html="parseSignDescription"
              ></div>
            </div>
          </div>

          <div v-if="languageStrings.terms && settings.termspage" class="mt-2">
            <a :href="settings.termspage">{{ languageStrings.terms }}</a>
          </div>
        </div>

        <div class="column column base-information__technical">
          <div class="terms">
            <div class="table-layout" v-if="getSign.saleprice !== '0'">
              <div class="label">{{ languageStrings.base_price }}</div>

              <div v-if="getSign.saleprice" class="label">
                <div v-if="getSign.saleprice" class="is-size-4">
                  <div class="price">
                    <span class="price__original">{{ getSign.price }}</span>
                    <span>{{ getSign.saleprice }}</span>
                    <span
                      v-if="languageStrings.currency_symbol"
                      v-html="languageStrings.currency_symbol"
                    ></span>
                  </div>
                </div>
                <span>{{ calculateVat(getSign.saleprice) }}</span>
                <span class="is-size-7" v-if="languageStrings.ex_vat">{{
                  languageStrings.ex_vat
                }}</span>
              </div>
            </div>

            <div class="table-layout" v-else>
              <div class="label">{{ languageStrings.base_price }}</div>
              <div v-if="getSign.price" class="is-size-4">
                <span class="price">
                  <span>{{ getSign.price }}</span>
                  <span
                    v-if="languageStrings.currency_symbol"
                    v-html="languageStrings.currency_symbol"
                  ></span>
                </span>
                <span v-if="getSign.price">
                  <span class="is-size-7">{{
                    calculateVat(getSign.price)
                  }}</span>
                  <span class="is-size-7" v-if="languageStrings.ex_vat">{{
                    languageStrings.ex_vat
                  }}</span>
                </span>
              </div>
            </div>

            <div
              class="table-layout mb-2"
              v-if="languageStrings.sku && getSign.sku"
            >
              <div class="label">{{ languageStrings.sku }}</div>
              <div>{{ getSign.sku }}</div>
            </div>

            <div v-if="languageStrings.material" class="table-layout mb-2">
              <div class="label">{{ languageStrings.material_title }}</div>
              <div>{{ languageStrings.color }}</div>
            </div>

            <div class="table-layout mt-2">
              <div class="label">{{ languageStrings.size }}</div>
              <div>{{ getSign.width }} x {{ getSign.height }} mm</div>
            </div>

            <div v-if="languageStrings.color" class="table-layout mt-2">
              <div class="label">{{ languageStrings.variant }}</div>
              <div>{{ languageStrings.material }}</div>
            </div>

            <div class="table-layout mt-2" v-if="getSign.interfaces">
              <div class="label" v-if="languageStrings.interface_application">
                <div>{{ languageStrings.interface_application }}</div>
              </div>

              <div>
                <ul>
                  <li
                    v-for="(interfaceItem, index) in getInterfaces()"
                    :key="index"
                  >
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_tape' &&
                        languageStrings.sign_interface_tape
                      "
                    >
                      {{ languageStrings.sign_interface_tape }}
                    </template>
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_militaryclip' &&
                        languageStrings.sign_interface_militaryclip
                      "
                    >
                      {{ languageStrings.sign_interface_militaryclip }}
                    </template>
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_screw' &&
                        languageStrings.sign_interface_screws
                      "
                    >
                      {{ languageStrings.sign_interface_screws }}
                    </template>
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_safetypin' &&
                        languageStrings.sign_interface_safetypin
                      "
                    >
                      {{ languageStrings.sign_interface_safetypin }}
                    </template>
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_metalmagnet' &&
                        languageStrings.sign_interface_metalmagnet
                      "
                    >
                      {{ languageStrings.sign_interface_metalmagnet }}
                    </template>
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_plasticmagnet' &&
                        languageStrings.sign_interface_plasticmagnet
                      "
                    >
                      {{ languageStrings.sign_interface_plasticmagnet }}
                    </template>
                    <template
                      v-if="
                        interfaceItem === 'sign_interface_keyring' &&
                        languageStrings.sign_interface_keyring
                      "
                    >
                      {{ languageStrings.sign_interface_keyring }}
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="mt-2">
            <ul>
              <li v-if="languageStrings.in_stock" class="in-stock mt-1">
                {{ languageStrings.in_stock }}
              </li>

              <li
                v-if="languageStrings.tape_included && getSign.hasholes !== '1'"
                class="mt-1"
              >
                <div class="product-promises-item tape-included">
                  {{ languageStrings.tape_included }}
                </div>
              </li>

              <li
                v-if="
                  languageStrings.screws_included && getSign.hasholes === '1'
                "
                class="mt-1"
              >
                <div class="product-promises-item screws-included">
                  {{ languageStrings.screws_included }}
                </div>
              </li>

              <li v-if="languageStrings.delivery_times" class="mt-1">
                {{ languageStrings.delivery_times }}
              </li>

              <li v-if="languageStrings.large_orders" class="mt-1">
                {{ languageStrings.large_orders }}
              </li>
            </ul>
          </div>
        </div>
        <div v-if="languageStrings.reservation" class="column is-full">
          <div class="mt-2">
            <div class="label">
              {{ languageStrings.reservation }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calculateVat from "../mixins/calculateVat";

export default {
  name: "ProductInformation",
  props: {
    getSign: {
      type: Object,
      default: {},
    },
    languageStrings: {
      type: Object,
      default: {},
    },
    settings: {
      type: Object,
      default: {},
    },
    siteSettings: {
      type: Object,
      default: {},
    },
  },
  mixins: [calculateVat],
  data() {
    return {
      counter: 0,
      showProductInformation: true,
      interfaceList: {},
    };
  },
  computed: {
    parseSignDescription() {
      // this.getSign.description.replace(/&quot;/g, "");
      const descriptionString = this.getSign.description.replace(
        /^"(.+(?="$))"$/,
        "$1",
      );
      return descriptionString;
    },
    interfaces() {
      if (this.getSign !== undefined) {
        return JSON.parse(this.getSign.interfaces);
      }
      return null;
    },
  },
  methods: {
    getInterfaces() {
      return (
        this.getSign?.interfaces.length > 0 &&
        JSON.parse(this.getSign.interfaces)
      );
    },
  },
};
</script>

<style scoped lang="scss">
.more-product-information {
  display: flex;

  @media (max-width: 768px) {
    display: none;
    padding: 0;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  a {
    color: var(--theme-link-color);
    text-decoration: underline;
  }

  @media (min-width: 768px) {
    display: none;

    &.show {
      display: flex;
    }
  }

  .label {
    font-weight: 600;
    margin-bottom: 0;
  }

  .in-stock::before {
    content: "";
    display: inline-block;
    vertical-align: initial;
    width: 11px;
    height: 11px;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 100%;
    background-color: var(--main-green);
  }

  .terms {
    margin-top: -12px;

    & > div {
      padding-top: 4px;
      margin-top: 4px;
      border-top: 1px solid #ddd;

      &.table-layout {
        display: flex;
        justify-content: space-between;
      }

      &:first-of-type {
        margin-top: 0;
        padding-top: 0;
      }

      .price {
        font-weight: 600;
        color: var(--orange);

        .price__original {
          font-size: 1rem;
          text-decoration: line-through;
          opacity: 0.5;
          margin-left: 6px;
        }
      }
    }

    @media (min-width: 992px) {
      margin-top: -8px;

      & > div {
        &:first-of-type {
          border-top: none;
        }
      }
    }
  }

  .base-information {
    margin-bottom: 1rem;

    &__header {
      padding-bottom: 0;

      h2 {
        margin-bottom: 0;
      }
    }

    &__description {
      @media (max-width: 768px) {
        padding-top: 0;
      }
    }

    &__technical {
      max-width: 550px;
      @media (max-width: 768px) {
        padding-top: 0;
        max-width: 100%;
      }
    }
    :deep {
      h2 {
        font-size: 1.4rem;
        margin-top: 10px;
      }
      h3 {
        font-size: 1.2rem;
        margin-top: 10px;
      }
      ul {
        margin: revert;
        padding: revert;
      }
    }
  }

  &-trigger {
    text-align: center;

    button {
      font-weight: 600;
      color: var(--main-black);
      border: none;
      background-color: transparent;

      &.active {
        &::after {
          transform: rotate(-180deg);
        }
      }

      &::after {
        content: "";
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-left: 5px;
        background-image: url("../../../images/svg/arrow-down.svg");
        background-size: contain;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }
}
</style>
